// Import Views
import { View } from "@/core/view";
import AccountManagement from "@/views/AccountManagement/AccountManagement";
import HouseholdSelection from "@/views/HouseholdSelection/HouseholdSelection";
import AccountSettings from "@/views/AccountSettings/AccountSettings";
import LoginResumeSession from "@/views/LoginResumeSession/LoginResumeSession";
import LotteryEnrollment from "@/views/LotteryEnrollment/LotteryEnrollment";
import SiteRentals from "@/views/SiteRentals/SiteRentals";

const view = new View();

view.register(AccountManagement.name, AccountManagement);
view.register(HouseholdSelection.name, HouseholdSelection);
view.register(AccountSettings.name, AccountSettings);
view.register(LoginResumeSession.name, LoginResumeSession);
view.register(LotteryEnrollment.name, LotteryEnrollment);
view.register(SiteRentals.name, SiteRentals);

export default view;

